<script setup>

import {computed, ref} from "vue";
import axios from "axios";
import { useNotificationStore } from '@/stores/NotificationStore.js'

const notificationStore = useNotificationStore()
const emit = defineEmits(['close'])

const props = defineProps({
    sharingTemplate: {
        type: Object,
        required: false,
        default: null
    }
})

const send = ref({
    email: '',
})

const shareTaskListTemplate = async () => {
    const response = await axios.post(route('api.task-list-template.share', props.sharingTemplate.id), {
        email: send.value.email,
    });

    if (response.data.success) {
        send.value.email = '';
        close()
        notificationStore.addNotification({
            type: 'success',
            title: response.data.message.title,
            message: response.data.message.body,
            dismissAfter: 5000,
        });
    } else {
        notificationStore.addNotification({
            type: 'error',
            title: 'Something went wrong',
            message: response.data.message,
            dismissAfter: 5000,
        });
    }
}

const close = () => {
    emit('close')
}

const inputValidates = computed(() => {
    return send.value.email.length > 0;
});

</script>

<template>
    <slideout-with-slots
        v-if="sharingTemplate !== null"
        :allow-self-close="true"
        title="Share task list template"
        @close="close"
    >
        <template #body>
            <div class="break-words whitespace-normal">
                <input-text
                    label="User email"
                    placeholder="Email address"
                    class="!mb-0"
                    v-model:content="send.email"
                />

                <div class="flex justify-end">
                    <button-base
                        :style-type="inputValidates ? 'primary' : 'disabled'"
                        :disabled="! inputValidates"
                        class="mt-3 text-center"
                        v-on:click="shareTaskListTemplate"
                    >
                        {{ send.email.length > 0 ? _mft('pagebuilderTemplate:sendTo', {email: send.email }) : _mft('pagebuilderTemplate:send') }}
                    </button-base>
                </div>
            </div>
        </template>
    </slideout-with-slots>
</template>

<style scoped>

</style>
